var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiLinkedinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:linkedin-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.94141 5.001C6.94114 5.53143 6.73017 6.04004 6.35491 6.41492C5.97965 6.78981 5.47084 7.00027 4.94041 7C4.40997 6.99974 3.90137 6.78877 3.52649 6.41351C3.1516 6.03825 2.94114 5.52943 2.94141 4.999C2.94167 4.46857 3.15264 3.95996 3.5279 3.58508C3.90316 3.21019 4.41197 2.99974 4.94241 3C5.47284 3.00027 5.98144 3.21123 6.35633 3.58649C6.73121 3.96175 6.94167 4.47057 6.94141 5.001ZM7.00141 8.481H3.00141V21.001H7.00141V8.481ZM13.3214 8.481H9.34141V21.001H13.2814V14.431C13.2814 10.771 18.0514 10.431 18.0514 14.431V21.001H22.0014V13.071C22.0014 6.901 14.9414 7.131 13.2814 10.161L13.3214 8.481Z",
    fill: "#1C1D1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiLinkedinFill);
export default __webpack_public_path__ + "static/media/ri_linkedin-fill.d791ae9be4b2053d76d08f7d24bc30fc.svg";
export { ForwardRef as ReactComponent };